import _axios from '../../apiClient'

export function GetAllProveedores() {
  return _axios
    .get(`/api/Proveedor/GetAllProveedores`, {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    })
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      console.log('Error en la petición de proveedor:', error)
      const data = error.response.data
      throw data
    });
}

export function GetProveedor() {
  return _axios
    .get(`/api/Proveedor/GetAllProveedores`, {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    })
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      console.log('Error en la petición de proveedor:', error)
      const data = error.response.data
      throw data
    });
}

export function getProveedorByCodigo(codigo) {
  return _axios.get(`/api/Proveedor/GetProveedorByCodigo`, {
      params: { codigo },
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
      const data = error.response.data;
      throw (data);
  });
}

export function getProveedorByNombre(nombre) {
  return _axios.get(`/api/Proveedor/GetProveedorByNombre`, {
      params: { nombre },
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
      const data = error.response.data;
      throw (data);
  });
}

export function saveProveedor(payload) {
  return _axios.post(`/api/Proveedor/SaveProveedor`, payload, {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
      const data = error.response.data;
      throw (data);
  });
}

export function deleteProveedor(idProveedor) {
  return _axios.delete(`/api/Proveedor/DeleteProveedor/${idProveedor}`, {
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
    const data = error.response.data;
    throw (data);
  });
}
